import { StateDataContext } from 'containers/Common/StateDataContext';
import { ScheduleConfig, ScheduleData } from 'core/rtbCampaign/ScheduleData';
import { get } from 'lodash';
import moment from 'moment';
import { useCallback, useContext, useMemo } from 'react';

export type ModifyScheduleStateContentModel = {
  anyCampaignStarted: boolean;
  defaultScheduleData: ScheduleData;
  minDate: string;
  maxDate: string;
  onDataChange: (newScheduleData: ScheduleData) => void;
  validateDateRange: (startDate: string, endDate: string) => string | undefined;
};

export const useModifyScheduleStateContentModel = (
  scheduleConfig: ScheduleConfig,
  validateDateRange: (startDate: string, endDate: string) => string | undefined
): ModifyScheduleStateContentModel => {
  const { data, setData } = useContext(StateDataContext);
  const { minStartDate, maxEndDate, campaigns } = scheduleConfig;
  const anyCampaignStarted = useMemo(
    () =>
      campaigns.some((campaigns) =>
        moment(campaigns.startDate).isBefore(moment())
      ),
    [campaigns]
  );
  const defaultScheduleData: ScheduleData = useMemo(
    () =>
      data || {
        enableStartDate: anyCampaignStarted ? false : true,
        startDate: minStartDate,
        enableEndDate: true,
        endDate: maxEndDate
      },
    [data, anyCampaignStarted, minStartDate, maxEndDate]
  );
  const onDataChange = useCallback(
    (newScheduleData: ScheduleData) => {
      const endDate = moment(newScheduleData.endDate)
        .endOf('minute')
        .format('YYYY-MM-DD HH:mm:ss');
      setData({
        ...newScheduleData,
        endDate
      });
    },
    [setData]
  );

  return {
    anyCampaignStarted,
    defaultScheduleData,
    minDate: moment()
      .add(1, 'hour')
      .startOf('hour')
      .format('YYYY-MM-DD HH:mm:ss'),
    maxDate: moment(get(scheduleConfig.order, 'endDate'))
      .endOf('day')
      .format('YYYY-MM-DD HH:mm:ss'),
    onDataChange,
    validateDateRange
  };
};
